import React, { useEffect, useMemo } from 'react';
import CensusStatistics from 'components/common/census/census-review/CensusStatistics';
import IMQCensusReviewPageStore, {
  useIMQCensusReviewPageStore,
  IMQCensusReviewPageStoreContext,
} from 'store/pages/quote/imq-add-employees/census-review/pageStore';
import { observer } from 'mobx-react-lite';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { RouteV2Id } from 'routes/routesConfigV2';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useIMQCensusReviewPageStore();
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const { flowDelegate } = pageStore;

  useEffect(() => {
    void flowDelegate.getFlowInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ groupId, periodId, cartId }}
      pageId={RouteV2Id.IMQ_ADD_EMPLOYEES_CENSUS_REVIEW}
      moreInfoBlob={
        flowDelegate.groupInfoDelegate.moreInfoBlobInput
          ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
          : undefined
      }
      isInfoSectionLoading={flowDelegate.isFlowDataLoading}
    >
      <CensusStatistics pageStore={pageStore} />
    </PageInFlowNoSidebarLayout>
  );
});

const IMQCensusReviewPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const pageStore = useMemo(
    () => new IMQCensusReviewPageStore({ groupId, enrollmentPeriodId: periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <IMQCensusReviewPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </IMQCensusReviewPageStoreContext.Provider>
  );
};

export default IMQCensusReviewPage;
